import { get } from '.';

export function GetEnrollerRunCustomers(enrollerRunId, options = {}) {
	return get<any>("/app/api/enroller_runs/" +  (enrollerRunId || 0).toString() + "/enroller_run_customers", options);
}

export function GetEnrollerRunCustomerExclusionReasonTotals(enrollerRunId, options = {}) {
	return get<any>("/app/api/enroller_runs/" +  (enrollerRunId || 0).toString() + "/enroller_run_customer_exclusion_reason_totals", options);
}

export function GetEnrollerRunCampaignCustomers(enrollerRunId, options = {}) {
	return get<any>("/app/api/enroller_runs/" +  (enrollerRunId || 0).toString() + "/campaign_customers", options);
}
